import React from 'react';
import {LabelDTO} from '../../models/dto/LabelDTO';
import {
    CheckboxContainer,
    ContentWrapper,
    DialogWrapper,
    Label,
    LabelFigure,
    LabelImage,
    LabelItem,
    LabelRatioWrapper
} from './LabelPicker.style';
import {t} from 'i18next';

export interface LabelsSelectionProps {
    readonly dataSource: LabelDTO[];
    readonly userLabels: string[];
    onChange: (userLabels: string[]) => void;
    userLabelsCount: number;
}

/**
 * @name LabelPicker
 * @description
 * Component to make a selection of labels that user can view on file tile/grid
 */
export const LabelPicker: React.VFC<LabelsSelectionProps> = (props) => {
    const saveLabel = (value: string) => {
        let userLabel = props.userLabels.slice();
        let keyIndex = userLabel.indexOf(value);
        if (keyIndex === -1) {
            userLabel.push(value);
        } else {
            userLabel.splice(keyIndex, 1);
        }

        props.onChange(userLabel);
    };

    const isSelected = (value: string): boolean => {
        if (props.userLabels != [] || props.userLabels.length >= 0) {
            return props.userLabels.includes(value);
        }

        return false;
    };

    const removeElement = (): void => {
        if (props.userLabels.length > 3) {
            let userLabel = props.userLabels.slice();
            userLabel.splice(userLabel.length - 1, 1);
            props.onChange(userLabel);
        }
    };

    const handleInput = (value: string) => {
        saveLabel(value);
    };

    return (
        <ContentWrapper>
            {(props.dataSource.length > 0) ?
                <Label htmlFor={'max-labels-reached'}>{t('MAXIMUM_NO_OF_LABELS')}</Label> :
                <Label htmlFor={'no-labels-available'}>{t('LABELS_NOT_AVAILABLE')}</Label>
            }
            {(props.dataSource.length > 0) && props.dataSource.map(showLabel => {
                return <div key={showLabel.labelKey}
                            className='a-selectable-tile a-selectable-tile--checkbox -large'>
                    <input
                        type='checkbox'
                        name='Selectable Tile Checkbox'
                        id={showLabel.labelKey}
                        checked={isSelected(showLabel.labelKey)}
                        onClick={() => handleInput(showLabel.labelKey)}
                    />
                    <LabelItem htmlFor={showLabel.labelKey}>
                        <CheckboxContainer className='checkbox-container'></CheckboxContainer>
                        <LabelFigure>
                            <LabelRatioWrapper>
                                <LabelImage src={showLabel.label}
                                            alt='Labels'
                                />
                                <div className='a-text'>
                                    <p className='-size-s highlight a-text__headline'>{showLabel.labelType}</p>
                                </div>
                            </LabelRatioWrapper>
                        </LabelFigure>
                    </LabelItem>
                </div>
            })}
            {(props.userLabelsCount > 3) ?
                <DialogWrapper
                    key={'key'} modal open title={t('INFO')} headline={t('MAXIMUM_NO_OF_LABELS')}
                    onClose={removeElement}>
                </DialogWrapper> : null}
        </ContentWrapper>
    );
};
